import { ScimWizardProvider } from "../../../../providers/ScimWizardProvider";
import ScimWizard from "./ScimWizard";

export default function ScimWizardWithProvider() {
	return (
		<ScimWizardProvider>
			<div style={{ height: "100%" }}>
				<ScimWizard />
			</div>
		</ScimWizardProvider>
	);
}
